/* eslint-disable no-underscore-dangle */

const PlatformSdk = require('@gluenetworks/platform-sdk-remote');

const ActionGroupEntity = PlatformSdk.entities.ws.ActionGroup;

class ActionGroupService {
  async getRolesForUserOrganizations() {
    const feed = await ActionGroupEntity.loadAscendActionGroups(this.getOrganizationId(), {
      systemInternal: false,
    });
    //  .loadAscendActionGroups('__authorizedTenants__', {});
    const rolesMap = {};
    feed.forEach((role) => {
      if (role.getPristineProperties().name) {
        rolesMap[role._id] = {
          id: role._id,
          value: role.getPristineProperties().name,
          label: role.getPristineProperties().name,
        };
      }
    });
    return Object.values(rolesMap);
  }

  getOrganizationId() {
    // eslint-disable-next-line no-underscore-dangle
    return window.DashboardComponent._userSession._activeOrganization.id;
  }
}

export default new ActionGroupService();
